import axios from "axios";
import store from "@/store";
import { Object } from "core-js";
import servicesRoutes from "@/http/services";
import flashMessages from '@/utils/flash-messages';
import { sendAbandonmentBeacon } from '@/utils/abandonmentBeacon';
//import pkg from '../../package';

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: { 
    'X-Requested-With': 'XMLHttpRequest',
    'X-Http-Owner-Id': process.env.VUE_APP_OWNER_ID
  }
})

http.interceptors.response.use(
  (response) => response,
  function(error) {
    const requestUrl = error.response?.config?.url || '';
    const isSendOffer = requestUrl === 'sendOffer' || requestUrl.endsWith('/sendOffer');
    if ((error.response?.status === 401 || error.response?.status === 419)
      && !isSendOffer
      && error.response?.config.url != 'updatePromoCode'
      && error.response?.config.url != 'mailings/token'
      && error.response?.config.url != 'auth/contacts'
      && error.response?.config.url != 'auth/sanctum/token') {
        const user    = store.state.auth?.user;
        const ownerId = store.state.auth?.ownerId;
        if (user?.DebtorID && ownerId) {
          sendAbandonmentBeacon(
            user.DebtorID,
            ownerId,
            user.PhoneNumber || null,
            'SESSION_EXPIRED',
          );
        }
        store.dispatch("auth/ActionDoLogout", { skipBeacon: true });
    }

    if (error.message === 'Network Error') {
      flashMessages.error('Não foi possível se comunicar com a API');
    }

    if (error.response?.status === 500) {
      flashMessages.error('Não foi possível executar a ação, tente novamente mais tarde.');
    }

    return Promise.reject(error.response ?? error);
  }
);

// rotas API organizadas
let services = {};

Object.keys(servicesRoutes).map((route) => {
  services[route] = servicesRoutes[route]
});

export const auth = services.auth;
export const divida = services.divida;
export const user = services.user;
export const cadastro = services.cadastro;
export const acordo = services.acordo;
export const comprovante = services.comprovante;
export const negociar = services.negociar;
export const vencimentoAVista = services.vencimentoAVista;
export const vencimentoParcelas = services.vencimentoParcelas;
export const acordoFechado = services.acordoFechado;
export const acordoFechadoParcelas = services.acordoFechadoParcelas;
export const propostas = services.propostas;
export const setBearerToken = token => {
  http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default {
  http,
};